import React from 'react'

function ThemeBody({children}) {
  return (
    <div className="main-wrapper d-flex min-vh-100 flex-column">
      {children}
    </div>
  )
}

export default ThemeBody